import React from "react";
import styled from "styled-components";

function Textarea({rows, className, label, name, onChange, onClick, value, id, help, placeholder, isInvalid, invalidFeedback, autoFocus, onKeyDown, ref, readOnly = false, charLength}) {
    return (
        <div className={"position-relative form-group " + (className ? className : "")}>
            {label ? <label htmlFor={id} dangerouslySetInnerHTML={{__html: label}}/> : ""}

            <Field
                ref={ref}
                onKeyDown={onKeyDown}
                autoFocus={autoFocus}
                name={name}
                rows={rows ?? 6}
                value={typeof value !== "undefined" ? value : ""}
                onChange={onChange}
                onClick={onClick}
                className={"form-control " + (isInvalid ? "is-invalid" : "")}
                id={id}
                placeholder={placeholder ?? ""}
                readOnly={readOnly}
            />

            {(typeof charLength !== "undefined" && charLength >=0) ? <CharLength>{charLength}</CharLength> : ''}

            {help ? <div className="form-text">{help}</div> : ""}

            {isInvalid ? (
                <div className="invalid-feedback">{invalidFeedback}</div>
            ) : (
                ""
            )}
        </div>
    );
}

export default Textarea;

// styles

const Field = styled.textarea`
  resize: none;

  &.is-invalid {
    padding-right: 1rem;
    padding-left: calc(1.8em + 1rem);
    background-position: left calc(0.45em + 0.25rem) center;
  }
`;

const CharLength = styled.span`
  position: absolute;
  left: 8px;
  bottom: -14px;
  background: #fff;
  color: ${props=> props.theme.gray300};
  padding: 0 4px;
  min-width: 28px;
  text-align: center;
`
